import { Distributor, DistributorId } from "./Product";

export interface StoreDistributor {
  readonly distributor: Distributor;

  readonly orderNotes: string;
  readonly orderWeekDays: string;
  readonly orderCutOffTime: string;

  readonly deliveryWeekDays: string;
  readonly deliveryTime: string;

  readonly weekInterval: number;

  readonly externalCustomerId?: string;
  readonly externalPassword?: string;

  readonly updated: Date;
  readonly created: Date;
}

export interface StoreDistributorWriteModel {
  readonly distributorId?: DistributorId;

  readonly orderNotes?: string;
  readonly orderWeekDays?: string;
  readonly orderCutOffTime?: string;

  readonly deliveryWeekDays?: string;
  readonly deliveryTime?: string;

  readonly weekInterval?: number;

  readonly externalCustomerId?: string;
  readonly externalPassword?: string;
}

export const toStoreDistributorWriteModel = (
  from: StoreDistributor
): StoreDistributorWriteModel => ({
  distributorId: from.distributor.id,
  orderNotes: from.orderNotes,
  orderWeekDays: from.orderWeekDays,
  orderCutOffTime: from.orderCutOffTime,
  deliveryWeekDays: from.deliveryWeekDays,
  deliveryTime: from.deliveryTime,
  weekInterval: from.weekInterval,
  externalCustomerId: from.externalCustomerId,
  externalPassword: from.externalPassword
});
